import css from './StatusText.module.css';
import { ReactNode } from 'react';

type StatusTextProps = {
  text: string;
  error: boolean;
  id?: string;
  tiny?: boolean;
  onClick?: React.MouseEventHandler;
  icon?: ReactNode;
};

const StatusText = ({ text, error, id, tiny, onClick, icon }: StatusTextProps) => {
  let className = css.status;
  className += ` ${error ? css.error : css.success}`;
  if (tiny) className += ` ${css.tiny}`;
  if (onClick !== undefined) className += ` ${css.link}`;

  return (
    <p id={id} className={className} onClick={onClick}>
      {icon && <span className={css.icon}>{icon}</span>}
      <span dangerouslySetInnerHTML={{ __html: text }} />
    </p>
  );
};

export default StatusText;
